interface IndustriesServedProps {
  onQuoteClick: () => void;
}

const industries = [
  { title: 'Construction & Infrastructure', img: 'https://readdy.ai/api/search-image?query=large%20construction%20site%20with%20steel%20structure%20building%20skyscraper%20workers%20dramatic%20sky&width=600&height=400&seq=ind-construction-1&orientation=landscape' },
  { title: 'Oil, Gas & Energy', img: 'https://readdy.ai/api/search-image?query=oil%20gas%20pipeline%20industrial%20energy%20plant%20steel%20pipes%20dramatic%20lighting&width=600&height=400&seq=ind-energy-1&orientation=landscape' },
  { title: 'Manufacturing & Industrial', img: 'https://readdy.ai/api/search-image?query=heavy%20manufacturing%20industrial%20factory%20steel%20production%20machinery&width=600&height=400&seq=ind-manufacturing-1&orientation=landscape' },
];

export default function IndustriesServed({ onQuoteClick }: IndustriesServedProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div className="md:w-2/3 text-center md:text-left">
            <span className="text-xs font-bold tracking-widest uppercase mb-2 block" style={{ color: '#0a2342' }}>Industries We Serve</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">Steel For Every Sector</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              From construction and infrastructure to oil &amp; gas and manufacturing — we source and supply the right steel products for your industry&apos;s specific requirements.
            </p>
          </div>
          <div className="md:w-1/3 flex md:justify-end justify-center">
            <button
              onClick={onQuoteClick}
              className="px-6 py-2.5 text-white text-sm font-bold rounded-md transition-colors whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#0a2342' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#0d2d56'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#0a2342'; }}
            >
              Get a Quote
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {industries.map((industry) => (
            <div key={industry.title} className="group relative rounded-lg overflow-hidden h-[240px] cursor-pointer">
              <img
                src={industry.img}
                alt={industry.title}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white text-base font-bold">{industry.title}</h3>
              </div>
              <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity" style={{ backgroundColor: '#0a2342' }}>
                <i className="ri-arrow-right-line text-white text-sm" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
